export default __webpack_public_path__ + "static/media/inc.25cc1099.svg";